var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<h1 class=\"heading clearfix\"><span class=\"pull-left\">Consumers</span> <small class=\"pull-right m-t-2\"><span ng-hide=\"$ctrl.query.isBusy()\">{{$ctrl.query.total}} result(s)</span> <span ng-show=\"$ctrl.query.isBusy()\">Loading...</span></small></h1>";
var id1="consumers-heading.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;